import { FaultTypeOption } from 'pages/Desk/issues/fault_type/FaultTypesInput';
import { memo } from 'react';
import { Lozenge } from 'shared/lozenge/Lozenge';

export type FaultTypeLozengeProps = Readonly<{
    faultType: FaultTypeOption;
    onRemove?: () => void;
}>;

function FaultTypeLozenge({ faultType, onRemove }: FaultTypeLozengeProps) {
    return (
        <Lozenge
            backgroundColor="var(--grey-default)"
            color="var(--text-primary-inverse)"
            onRemove={onRemove}
        >
            {faultType.FullName}
        </Lozenge>
    );
}

const memoFaultTypeLozenge = memo(FaultTypeLozenge);
export { memoFaultTypeLozenge as FaultTypeLozenge };
